#import '../fragments/stage-lead-slack-message-data-fragment.graphql'

query GetSlackMessagesForStage($stageId: ID!) {
    stage(id: $stageId) {
        id
        ...StageSlackMessageData
    }
}
